import * as React from 'react'

export const ColAuto = props => <div className="col-auto" {...props} />
